import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate, useParams } from "react-router-dom";
import { AuthProvider } from "@/context/AuthContext";
import Layout from "@/components/layout/Layout";
import ProtectedRoute from "@/components/ProtectedRoute";
import ScrollToTop from "@/components/ScrollToTop";

import Home from "@/pages/Home";
import About from "@/pages/About";
import Memberships from "@/pages/Memberships";
import Affiliations from "@/pages/Affiliations";
import Coaches from "@/pages/Coaches";
import { ChampionshipsList, ChampionshipDetail } from "@/pages/Championships";
import Events from "@/pages/Events";
import Examinations from "@/pages/Examinations";
import Downloads from "@/pages/Downloads";
import News from "@/pages/News";
import MediaCenter from "@/pages/MediaCenter";
import Women from "@/pages/Women";
import Para from "@/pages/Para";
import Scholarships from "@/pages/Scholarships";
import Contact from "@/pages/Contact";
import Register from "@/pages/Register";
import Login from "@/pages/Login";
import Recognitions from "@/pages/Recognitions";
import Zones from "@/pages/Zones";
import Certificates from "@/pages/Certificates";
import CoachDashboard from "@/pages/dashboards/CoachDashboard";
import OfficialsDashboard from "@/pages/dashboards/OfficialsDashboard";
import AdminDashboard from "@/pages/dashboards/AdminDashboard";

const Wrap = ({ children }) => <Layout>{children}</Layout>;

function DashboardRouter() {
  const { role } = useParams();
  if (role === "coach") return <CoachDashboard />;
  if (role === "official") return <OfficialsDashboard />;
  if (role === "admin") return <AdminDashboard />;
  return <Navigate to="/" replace />;
}

function AppRoutes() {
  return (
    <Routes>
      <Route path="/" element={<Wrap><Home /></Wrap>} />
      <Route path="/about" element={<Wrap><About /></Wrap>} />
      <Route path="/memberships" element={<Wrap><Memberships /></Wrap>} />
      <Route path="/affiliations" element={<Wrap><Affiliations /></Wrap>} />
      <Route path="/coaches" element={<Wrap><Coaches /></Wrap>} />
      <Route path="/championships" element={<Wrap><ChampionshipsList /></Wrap>} />
      <Route path="/championships/:id" element={<Wrap><ChampionshipDetail /></Wrap>} />
      <Route path="/events" element={<Wrap><Events /></Wrap>} />
      <Route path="/examinations" element={<Wrap><Examinations /></Wrap>} />
      <Route path="/downloads" element={<Wrap><Downloads /></Wrap>} />
      <Route path="/news" element={<Wrap><News /></Wrap>} />
      <Route path="/media" element={<Wrap><MediaCenter /></Wrap>} />
      <Route path="/women" element={<Wrap><Women /></Wrap>} />
      <Route path="/para" element={<Wrap><Para /></Wrap>} />
      <Route path="/scholarships" element={<Wrap><Scholarships /></Wrap>} />
      <Route path="/contact" element={<Wrap><Contact /></Wrap>} />
      <Route path="/register" element={<Wrap><Register /></Wrap>} />
      <Route path="/recognitions" element={<Wrap><Recognitions /></Wrap>} />
      <Route path="/zones" element={<Wrap><Zones /></Wrap>} />
      <Route path="/certificates" element={<Wrap><Certificates /></Wrap>} />

      {/* Auth */}
      <Route path="/login" element={<Login />} />

      {/* Dashboards */}
      <Route
        path="/dashboard/:role"
        element={
          <ProtectedRoute>
            <DashboardRouter />
          </ProtectedRoute>
        }
      />

      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <ScrollToTop />
        <AppRoutes />
      </AuthProvider>
    </BrowserRouter>
  );
}
